import { Button, Flex, Input } from 'antd'
import { FormItem } from '../../../../components/form-item'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StoreInput } from '../../../input/store-input'
import { DETAILS, useCreateCampaignStepsContext } from '../campaign-create-steps-context'
import { Paragraph } from '../paragraph'
import clsx from 'clsx'
import { Title } from '../title'
import { CampaignLanguageSettings } from '../../campaign-language-settings'

import { ToolEditor } from '../../../../app-connection/components/tool-editor'

export function PromptDetailsStep() {
    const { t } = useTranslation()
    const { currentStep, current, previousStep, nextStep, activeAgentConfig } = useCreateCampaignStepsContext()

    const visible = currentStep === DETAILS

    return (
        <div className={clsx({ hidden: !visible })}>
            <Title>{t('Conversation instructions')}</Title>
            <Paragraph type="secondary">{t(activeAgentConfig?.description || '')}</Paragraph>
            <FormItem<StoreInput>
                name="title"
                label={t('Campaign name')}
                rules={[{ required: true, whitespace: true }]}
            >
                <Input placeholder={t('Enter title')} />
            </FormItem>
            <FormItem<StoreInput>
                name={['data', 'prompt']}
                label={t('Conversation instructions')}
                rules={[{ required: true, whitespace: true, message: t('Enter your conversation instructions') }]}
            >
                <Input.TextArea
                    key={visible ? 'visible' : 'hidden'}
                    placeholder={t('Describe the goal, tone, approach and how to evaluate the outcome')}
                    autoSize={{ minRows: 6, maxRows: 25 }}
                />
            </FormItem>
            <CampaignLanguageSettings className="mb-6" />
            {activeAgentConfig?.type === 'custom' && <ToolEditor creation />}
            <Flex justify="space-between">
                {current > 0 ? (
                    <Button
                        size="large"
                        onClick={previousStep}
                    >
                        {t('Back')}
                    </Button>
                ) : (
                    <div />
                )}
                <Button
                    size="large"
                    type="primary"
                    onClick={nextStep}
                >
                    {t('Continue')}
                </Button>
            </Flex>
        </div>
    )
}
